import {makeObservable, observable, action} from "mobx";
import apiService from "../services/apiServices";
import { cacheService } from "../services/cacheService";

class DepartmentStore {
    userType = false;
    selectedUserType = null;
    departmentTypes = null;

    constructor() {
        makeObservable(this, {
            userType: observable,
            departmentTypes: observable,
            selectedUserType: observable,
            setUserType: action.bound,
            getDepartmentTypes: action.bound,
            selectDepartmentType: action.bound,
            setSelectedUserType: action.bound,
        });
    }


    getDepartmentTypes = async () => {
        const {data: {data:departmentTypes}} = await apiService.getDepartmentTypes();
        this.departmentTypes = departmentTypes;
    };

    selectDepartmentType = async (id) => {
        return await apiService.setUserNameById(cacheService.getMyId, {
            user_type: id
        });
    };

    setUserType = (bool) => {
        this.userType = bool;
    };
    
    setSelectedUserType = (type) => {
        this.selectedUserType = type;
    };
}

export const departmentStore = new DepartmentStore();